import { render, staticRenderFns } from "./modals-global.vue?vue&type=template&id=0bb0d619"
import script from "./modals-global.vue?vue&type=script&lang=js"
export * from "./modals-global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports